import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getAccountUsers } from "../../api/users";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { UserResponse } from "../../types/model/user/UserResponse";

const NO_USERS: UserResponse[] = [];
const STALE_TIME = 5 * 60 * 1000;

export const useAccountUsers = (accountIds: (number | null | undefined)[], enabled: boolean) => {
  const handleError = useErrorHandler();
  const ids = Array.from(new Set(accountIds.filter((id): id is number => !!id))).sort((a, b) => a - b);

  const query = useQuery({
    queryKey: ["account-users", ids],
    queryFn: async () => {
      const lists = await Promise.all(ids.map((id) => getAccountUsers(id)));
      return Array.from(new Map(lists.flat().map((u) => [u.id, u])).values());
    },
    enabled: enabled && ids.length > 0,
    staleTime: STALE_TIME,
  });

  useEffect(() => {
    if (query.error) handleError(query.error);
  }, [query.error]);

  return { users: query.data ?? NO_USERS, isLoading: query.isLoading };
};